export const useSellerRule = `공고일자: 2026년 10월 1일 · 시행일자: 2026년 10월 1일
제1장 총칙
제1조 (목적)
이 약관은 기역기역 주식회사(이하 "회사")가 운영하는 라이브커머스 플랫폼 팬버드(이하 "플랫폼")에 입점하여 라이브 방송과 상품 판매를 하는 셀러와 회사 간의 권리, 의무 및 책임사항을 정함을 목적으로 합니다.
제2조 (용어의 정의)
① "셀러"란 이 약관에 동의하고 회사의 입점 심사를 거쳐 승인을 받은 사업자를 말합니다.
② "고객"이란 플랫폼에 가입하여 셀러를 팔로우하고 상품을 구매하는 회원을 말합니다.
③ "셀러 개별약관"이란 셀러가 플랫폼에 등록하여 고객에게 제시하고 동의를 받는 해당 셀러의 판매조건을 말합니다.
④ "코인(C)"이란 셀러가 라이브 송출, 알림 발송 등 플랫폼 이용요금을 지급하기 위해 미리 충전하는 이용권을 말하며, 대금을 지급하고 충전한 "유상 코인"과 회사가 프로모션 등으로 무상 지급한 "무상 코인"으로 구분합니다.
⑤ "요금표"란 회사가 코인 차감 기준, 수수료 등 이용요금을 정하여 셀러센터에 게시한 기준을 말합니다.
⑥ "운영정책"이란 이 약관의 위임에 따라 회사가 판매금지 품목, 방송 기준, 제재 기준 등 세부 사항을 정하여 셀러센터에 게시한 기준을 말합니다.
⑦ "PG결제"는 회사가 지정한 전자결제대행사를 통한 결제를, "무통장 입금"은 고객이 셀러 명의 계좌로 대금을 직접 이체하는 결제를 말합니다.
제3조 (약관의 게시와 개정)
① 회사는 이 약관을 셀러센터에 게시하며, 관련 법령을 위배하지 않는 범위에서 개정할 수 있습니다.
② 회사는 개정 시 적용일자와 개정사유를 7일 전부터 공지하며, 셀러에게 불리한 변경(요금 인상 포함)은 30일 전부터 공지하고 이메일 또는 알림톡으로 개별 통지합니다.
③ 회사가 기간 내 거부 의사를 표시하지 않으면 동의한 것으로 본다는 뜻을 명확히 알렸음에도 셀러가 거부하지 않으면 개정 약관에 동의한 것으로 봅니다. 동의하지 않는 셀러는 이용계약을 해지할 수 있습니다.
제4조 (운영정책과 요금표)
① 운영정책과 요금표는 이 약관의 일부를 이루며, 그 변경은 제3조의 절차를 따릅니다.
② 운영정책이 이 약관과 다른 경우 이 약관이 우선합니다.
제5조 (회사의 지위)
① 회사는 통신판매중개자로서 셀러와 고객 간 거래를 위한 플랫폼을 제공하며, 셀러가 판매하는 상품의 거래 당사자는 셀러입니다.
② 셀러는 상품의 정보, 품질, 적법성, 배송, 교환·반품·환불 및 고객 응대에 대한 모든 책임을 집니다.
③ 회사는 전자상거래법에 따라 셀러의 상호, 대표자 성명, 주소, 전화번호, 이메일, 사업자등록번호, 통신판매업 신고번호를 셀러 페이지에 공개하며, 셀러는 이에 동의합니다.
제2장 입점
제6조 (입점 신청)
① 입점을 원하는 사업자는 이 약관과 셀러 개인정보 처리방침에 동의하고 다음 서류와 정보를 제출하여야 합니다.
1. 사업자등록증, 통신판매업 신고증(신고 대상인 경우)
2. 대표자 본인확인(휴대전화 본인인증 또는 주민등록번호 뒷자리를 가린 신분증 사본)
3. 정산 및 무통장 입금용 사업자 명의 계좌(통장 사본)
4. 취급 품목에 따른 인허가·신고 서류(식품, 건강기능식품, 화장품 등)
② 셀러는 제출 정보가 사실과 같음을 보증하며, 변경되면 7일 이내에 셀러센터에서 수정하여야 합니다.
제7조 (입점 심사와 거절)
① 회사는 서류, 상품 품질, 판매 이력 등을 심사하여 승인 여부를 정하고 그 결과를 이메일 또는 알림톡으로 알립니다.
② 회사는 다음 각 호의 경우 입점을 거절하거나 승인 후 계약을 해지할 수 있습니다.
1. 허위 서류 제출 또는 타인 명의 도용
2. 가품 판매, 상표권 침해 등으로 플랫폼(타 플랫폼 포함)에서 제재받은 이력이 확인되는 경우
3. 창고주, 도매상, 재고 처분(땡처리) 업자로 활동한 이력이 있는 경우. 다만 소매 판매만 하겠다는 확약서를 제출하면 심사할 수 있습니다.
4. 판매금지 품목을 주로 취급하거나 단일 상품만 판매하려는 경우
5. 특정 카테고리에 입점이 과도하게 몰려 운영상 제한이 필요한 경우
6. 이전에 회사로부터 계약 해지를 당한 경우
제8조 (계정 관리와 양도 금지)
① 셀러는 계정과 송출앱 접속정보를 직접 관리하며, 계정이나 코인을 타인에게 양도·대여할 수 없습니다.
② 직원 등에게 하위 계정을 부여한 경우 그 사용에 대한 책임은 셀러에게 있습니다.
제3장 서비스 이용
제9조 (제공 서비스)
회사는 셀러에게 라이브 송출(송출앱), 셀러 페이지와 팔로우 관리, 상품·주문 관리, 고객 알림 발송, 정산 내역 조회, 판매 통계 등 셀러센터 기능을 제공합니다.
제10조 (셀러 개별약관)
① 셀러는 판매 시작 전에 셀러 개별약관을 셀러센터에 등록하여야 하며, 다음 사항을 포함하여야 합니다.
1. 결제수단(PG결제 또는 무통장 입금)과 무통장 입금 시 입금 기한
2. 배송 방법, 배송비, 발송 소요기간
3. 교환·반품·환불 조건과 비용 부담, 반품 주소
4. 청약철회가 제한되는 상품과 그 사유
5. 고객 문의 응대 방법과 시간
② 셀러 개별약관은 관련 법령과 회사의 고객 이용약관보다 고객에게 불리할 수 없으며, 불리한 부분은 효력이 없습니다.
③ 회사는 셀러 개별약관이 법령에 어긋나거나 고객에게 부당하게 불리하다고 판단하면 수정을 요청하거나 노출을 중단할 수 있습니다. 이는 회사의 협조 조치이며, 셀러 개별약관의 적법성에 대한 책임은 셀러에게 있습니다.
④ 고객은 주문 전에 셀러 개별약관을 확인하고 동의하며, 회사는 그 동의 기록을 보관합니다. 셀러 개별약관을 변경한 경우 변경 전 주문에는 종전 내용이 적용됩니다.
제11조 (상품 등록과 표시)
① 셀러는 상품정보제공고시, 가격, 배송비, 원산지, 인허가 사항 등 관련 법령이 정한 정보를 정확히 표시하여야 합니다.
② 라이브 방송에서 안내한 조건과 상품 페이지가 다른 경우 고객에게 유리한 조건을 적용합니다.
제12조 (라이브 방송)
① 셀러는 송출앱을 통해 운영정책에서 정한 기준에 맞게 방송하여야 하며, 방송 중 다음 행위를 하여서는 안 됩니다.
1. 음주, 흡연
2. 과도한 신체 노출, 선정적이거나 불쾌감을 주는 콘텐츠. 속옷·수영복을 직접 착용하여 피팅할 경우 이너웨어를 반드시 함께 착용하여야 하며 마네킹 피팅을 권장합니다.
3. 다른 셀러나 회사에 대한 비방
4. 다른 플랫폼과 동시 송출하면서 다른 플랫폼에서 주문·결제를 받거나 언급하는 행위
5. 허위·과장 광고, 근거 없는 효능 표현(특히 식품·건강기능식품·화장품)
② 회사는 제1항 또는 제22조·제23조 위반이 명백한 경우 진행 중인 방송을 즉시 중단시킬 수 있으며, 사후에 그 사유를 알립니다.
제13조 (영상물의 이용 허락)
① 셀러가 제작한 라이브 방송 영상의 저작권과 출연자의 초상권은 셀러에게 있습니다.
② 셀러는 회사에 플랫폼 운영과 셀러·플랫폼 홍보(회사 공식 SNS 업로드, 숏폼 제작 등)를 위해 영상을 무상으로 이용, 복제, 편집, 전송할 수 있는 비독점적 권리를 계약기간 동안 부여합니다.
③ 셀러는 출연자, 음원, 이미지 등 영상에 포함된 제3자 권리를 확보할 책임이 있습니다.
④ 계약이 끝나면 회사는 영상을 새로 홍보에 쓰지 않으며, 셀러가 요청하면 이미 게시한 홍보물을 합리적인 기간 내에 내립니다. 다만 법령상 보존 의무가 있는 기록은 예외로 합니다.
제4장 결제, 정산, 코인
제14조 (이용요금)
① 셀러는 요금표에 따라 코인 차감 방식으로 이용요금을 지급합니다.
② PG결제 수수료는 결제수단별로 전자결제대행사가 정한 요율에 따라 셀러가 부담합니다.
제15조 (결제수단 선택과 대금 수령)
① 셀러는 고객의 결제수단으로 PG결제와 무통장 입금 중 하나 이상을 선택합니다.
② PG결제를 쓰려는 셀러는 회사가 지정한 전자결제대행사(주식회사 헥토파이낸셜)의 심사를 받아야 하며, 판매대금은 회사가 전자결제대행사를 통해 받아 정산주기에 따라 셀러에게 지급합니다. 정산은 구매확정일부터 9 영업일 이내에 하며, 회사는 청약철회나 분쟁이 진행 중인 주문의 대금은 처리 완료 시까지 정산을 보류하고, 고객 환급금과 이용요금 등 셀러가 회사에 지급할 금액을 정산금에서 공제할 수 있습니다.
③ 무통장 입금을 쓰는 셀러는 다음을 지켜야 합니다.
1. 셀러센터에 등록한 셀러(사업자) 명의 계좌로만 대금을 받으며, 채팅·문자·전화 등으로 다른 계좌나 외부 결제 링크를 안내하지 않습니다.
2. 입금 확인을 지체 없이 셀러센터에 처리하고, 입금 기한이 지난 주문은 취소합니다.
3. 관련 법령에 따라 결제대금예치(에스크로) 또는 소비자피해보상보험 등 구매안전서비스를 고객이 선택할 수 있도록 제공하고, 그 사실을 셀러 개별약관에 표시합니다.
4. 현금영수증 발급과 매출 신고를 직접 합니다.
5. 환불이 필요하면 반품 상품을 받은 날부터 3영업일 이내에 고객 계좌로 환급합니다.
④ 무통장 입금 대금은 회사를 거치지 않으므로, 대금 수령·환불에 관한 책임은 셀러에게 있습니다. 회사는 고객 민원이 접수되면 셀러에게 확인과 이행을 요청할 수 있습니다.
제16조 (코인 충전)
① 코인은 회사가 지정한 회사 명의 계좌로 셀러가 직접 이체하여 충전합니다. 셀러는 셀러센터에서 충전 신청 후 안내된 입금자명으로 이체하여야 합니다.
② 회사는 입금을 확인한 후 1영업일 이내에 유상 코인을 지급하며, 입금자명이나 금액이 다른 경우 확인이 늦어질 수 있습니다.
③ 회사는 충전 금액에 대해 부가가치세법에 따른 세금계산서를 발행합니다. 코인 1C의 가격과 최소 충전 단위는 요금표에 따릅니다.
제17조 (코인의 사용과 차감)
① 코인은 선충전 후사용 방식으로, 라이브 송출, 알림 발송 등 요금표에서 정한 기준에 따라 차감됩니다.
② 무상 코인이 있는 경우 무상 코인을 먼저 차감합니다.
③ 잔액이 부족하면 방송 예약, 송출, 알림 발송이 제한될 수 있으며, 회사는 잔액 부족 예상 시 미리 알립니다.
④ 셀러는 셀러센터에서 충전·차감 내역을 확인할 수 있으며, 차감에 이의가 있으면 차감일부터 30일 이내에 이의를 제기할 수 있습니다. 회사는 확인 후 잘못 차감된 코인을 돌려줍니다.
⑤ 회사의 시스템이나 서버 장애로 방송이 중단된 경우 해당 차감분을 돌려줍니다. 셀러의 네트워크, 기기, 방송 환경 문제로 인한 차감분은 돌려주지 않습니다.
제18조 (무상 코인)
무상 코인은 회사가 정한 조건과 유효기간 내에서만 쓸 수 있으며, 환불, 현금화, 양도할 수 없습니다. 부정한 방법으로 받은 무상 코인은 회수합니다.
제19조 (코인의 환불과 소멸)
① 셀러는 미사용 유상 코인의 환불을 신청할 수 있으며, 회사는 신청일부터 7영업일 이내에 셀러 명의 계좌로 환불합니다. 이체 수수료 등 실비는 공제할 수 있습니다.
② 충전 시 함께 지급된 보너스(무상) 코인을 이미 사용한 경우, 그 사용분에 해당하는 금액을 환불액에서 공제할 수 있습니다.
③ 계약 해지(퇴점) 시 남은 유상 코인은 제1항에 따라 환불합니다. 셀러의 귀책으로 계약이 해지된 경우에도 같으며, 다만 회사는 셀러의 위반으로 입은 손해액을 공제할 수 있습니다.
④ 유상 코인은 마지막 충전일 또는 사용일부터 5년간 사용하지 않으면 소멸하며, 회사는 소멸 30일 전에 알립니다.
제5장 셀러의 의무
제20조 (배송)
① 셀러는 결제(무통장은 입금 확인)일부터 7일 이내에 상품을 발송하고 송장번호를 등록하여야 합니다.
② 7일을 넘기는 경우 사전에 고객에게 사유와 예정일을 알려야 하며, 알리지 않고 지연하면 경고 대상이 됩니다. 상습 지연은 이용이 제한될 수 있습니다.
제21조 (고객 응대와 청약철회 처리)
① 셀러는 플랫폼 내 1:1 문의를 통해 고객 문의에 2영업일 이내에 응답하여야 하며, 고객에게 외부 채널로 문의하도록 요구할 수 없습니다.
② 셀러는 전자상거래법이 정한 청약철회 기간, 비용 부담, 환급 기한(반품 상품 수령 후 3영업일)을 지켜야 합니다.
③ 회사는 고객 민원이 정당하다고 판단하면 셀러에게 처리를 요청하며, 셀러는 이에 성실히 응하여야 합니다.
제22조 (고객 개인정보 보호)
① 셀러는 회사로부터 제공받은 고객 정보(이름, 연락처, 주소 등)를 배송, 교환·반품, 고객상담 목적으로만 이용하며, 이 범위에서 개인정보 보호법상 개인정보처리자로서 책임을 집니다.
② 셀러는 고객 정보를 마케팅, 개인 연락, 외부 채널 홍보, 제3자 제공에 사용할 수 없습니다.
③ 고객 정보는 주문일부터 3개월 이내에만 셀러센터에서 열람·다운로드할 수 있으며, 셀러는 다운로드한 정보를 목적 달성 후 지체 없이 파기하여야 합니다.
④ 셀러는 고객 정보가 유출된 사실을 안 경우 즉시 회사에 알리고, 법령에 따른 신고·통지 의무를 이행하여야 합니다.
⑤ 회사가 승인한 경우를 제외하고, 라이브 시작 알림 등 고객 알림은 회사 시스템으로만 발송합니다.
제23조 (지식재산권 침해와 가품 금지)
① 셀러는 가품·이미테이션을 판매할 수 없으며, 이미테이션임을 미리 알린 경우에도 같습니다.
② 셀러는 상품명, 상세설명, 방송에서 권리자 허락 없이 브랜드명을 쓰거나 특정 브랜드를 연상시키는 표현(예: ~스타일, ~st, ~풍, ~형, A급·특A급, 브랜드명 일부를 가린 표기)을 쓸 수 없습니다.
③ 정품과 함께 구성한 사은품(노벨티)이 정품이 아니면 전체 상품을 가품으로 봅니다.
④ 회사는 권리자 신고나 가품 의심이 있는 경우 판매를 임시 중단하고 정품 소명 서류(브랜드 인보이스·영수증, 수입신고필증, 정품 감정서 등)를 요청할 수 있습니다. 셀러는 요청일부터 3일 이내에 가림 처리 없는 서류를 제출하여야 하며, 기한 내 제출하지 않거나 소명이 부족하면 소명될 때까지 판매가 정지됩니다.
⑤ 위조·변조 서류를 제출하거나 가품을 정품으로 속여 판매한 경우 회사는 경고 없이 계약을 해지할 수 있습니다.
제24조 (판매금지 품목)
셀러는 다음 상품을 판매할 수 없으며, 세부 목록은 운영정책에 따릅니다.
1. 가품, 이미테이션, 상표권·디자인권을 침해하는 상품
2. 총포·도검류, 마약류, 담배, 주류(법령상 통신판매가 허용되는 전통주 등은 운영정책에 따름), 의약품
3. 실물이 없는 상품(보험, 금융상품, 이용권, 강의, 여행, 부동산, 휴대폰 개통 등). 다만 회사가 별도로 허용한 경우는 예외입니다.
4. 자동차 등 고가 등록 재산
5. 그 밖에 법령이 판매를 금지·제한하거나 인허가 없이 판매할 수 없는 상품
제25조 (외부 채널 홍보와 직거래 금지)
① 셀러는 플랫폼 내에서 또는 플랫폼 고객에게 셀러의 외부 채널(밴드, 카카오채널, 인스타그램, 자사몰, 다른 라이브커머스 등)을 홍보하거나 직거래를 유도할 수 없습니다. 다음은 그 예입니다.
1. 이벤트를 미끼로 외부 채널 가입이나 방문을 유도하는 행위
2. "더 많은 상품은 외부 채널에서" 등 외부 채널을 직간접적으로 언급하는 행위
3. 고객 문의, 배송 조회, 후기, 이벤트를 외부 채널로 안내하는 행위
4. 플랫폼에서 얻은 고객 정보로 단체 메시지를 보내거나, 택배 동봉물에 외부 채널 정보를 넣는 행위
5. 방송 화면에 외부 채널이나 자사몰 화면을 비추는 행위
② 셀러가 플랫폼 밖에서 팬버드를 홍보하는 것은 제한하지 않습니다.
제26조 (그 밖의 금지행위)
셀러는 다음 행위를 하여서는 안 됩니다.
1. 다른 셀러 방송에 허위 주문·취소를 반복하거나 여론을 조작하는 등 방송을 방해하는 행위
2. 허위 후기 작성·유도, 대가성 후기를 표시 없이 게시하는 행위
3. 회사 임직원 사칭, 시스템 비정상 접근
4. 다른 셀러와의 분쟁을 이유로 공개적으로 회사나 다른 셀러의 명예를 훼손하는 행위. 셀러 간 분쟁은 당사자 간 또는 공정거래위원회 등 분쟁조정기관을 통해 해결합니다.
제27조 (비밀유지)
셀러와 회사는 계약 조건, 개별 요율 등 상대방의 영업상 비밀을 계약기간과 종료 후 2년간 제3자에게 공개하지 않습니다. 다만 법령에 따른 공개는 예외로 합니다.
제6장 제재와 계약 종료
제28조 (위반 시 조치)
① 회사는 셀러가 이 약관이나 운영정책을 위반하면 위반의 경중과 횟수에 따라 다음과 같이 조치할 수 있습니다.
단계
조치
경미한 위반(배송 지연 등)
경고, 시정 요청
반복 위반
이용정지 3일 → 7일 → 14일 → 30일 → 60일 순으로 가중
부수 조치
마케팅·프로모션 혜택 중단, 브랜드 상품 판매 금지, 무상 코인 회수
중대 위반
경고 없이 계약 해지(퇴점)
② 중대 위반은 다음 각 호를 말합니다.
1. 가품을 정품으로 속여 판매하거나 위조 서류를 제출한 경우
2. 고객 개인정보를 목적 외로 이용하거나 외부 채널로 고객을 유도한 경우
3. 판매금지 품목을 판매한 경우
4. 방송 중 음주·흡연, 음란 행위를 한 경우
5. 상품 판매와 관련하여 형사처벌을 받은 경우
③ 회사는 조치 전에 사유를 알리고 7일 이상의 소명 기회를 주며, 고객 피해 확산 등 긴급한 경우 먼저 조치한 후 알릴 수 있습니다. 셀러는 조치에 대해 이의를 제기할 수 있습니다.
④ 이용정지 중에도 이미 접수된 주문의 배송과 고객 응대 의무는 계속됩니다.
제29조 (조사 협조)
회사는 위반이 의심되는 경우 사실 확인을 위해 셀러에게 거래 증빙, 상품 수급·배송 서류 등 필요 최소한의 자료를 요청할 수 있으며, 셀러는 15일 이내에 제출하여야 합니다.
제30조 (셀러의 해지)
셀러는 셀러센터 또는 고객센터를 통해 언제든지 퇴점을 신청할 수 있습니다. 진행 중인 주문, 교환·반품, 정산을 마친 후 계약이 종료되며, 남은 유상 코인은 제19조에 따라 환불합니다.
제31조 (회사의 해지)
회사는 제7조 제2항의 사유가 확인되거나 제28조 제2항의 중대 위반이 있는 경우, 또는 시정 요청 후 14일 이내에 시정하지 않는 경우 계약을 해지할 수 있습니다.
제32조 (계약 종료 후 처리)
계약이 종료되어도 종료 전 주문에 대한 셀러의 배송, 청약철회 처리, 고객 응대 책임과 제22조의 개인정보 보호 의무는 유지됩니다. 회사는 법령상 보존 기록을 제외한 셀러 계정 정보를 셀러 개인정보 처리방침에 따라 처리합니다.
제7장 기타
제33조 (손해배상)
① 회사 또는 셀러가 이 약관을 위반하여 상대방에게 손해를 입힌 경우 그 손해를 배상합니다.
② 셀러의 위반으로 회사가 고객, 권리자, 관계기관에 배상하거나 비용을 지출한 경우 셀러는 이를 회사에 배상합니다.
제34조 (회사의 면책)
회사는 천재지변 등 불가항력, 셀러의 네트워크·기기·방송 환경 문제, 셀러와 고객 간 거래에서 셀러의 귀책으로 생긴 손해에 대해서는 책임을 지지 않습니다. 다만 회사의 고의 또는 과실이 있는 경우에는 그러하지 않습니다.
제35조 (통지)
회사는 셀러가 등록한 이메일, 휴대전화번호(알림톡) 또는 셀러센터 공지로 통지합니다.
제36조 (준거법 및 관할)
이 약관에 관한 분쟁에는 대한민국 법률을 적용하며, 회사 본점 소재지를 관할하는 지방법원을 합의관할 법원으로 합니다.
부칙
이 약관은 2026년 10월 1일부터 시행합니다.
사업자 정보
• 상호: 기역기역 주식회사 / 대표자: 이헌영
• 사업자등록번호: 669-87-03262
• 주소: 전남광주통합특별시 동구 필문대로 287번길 3
• 전화: 0507-1336-7115 / 이메일: linkcampus01@gmail.com`;
